import React, { FunctionComponent } from 'react';
import Media from 'react-media';
import styled from 'styled-components';

import { Text } from 'components/chroma';

import { loginUrl } from 'scenes/common/helpers/contacts';
import { SCREEN } from 'scenes/common/types/screen';
import AccountCreatedHeader from './AccountCreatedHeader';

const DesktopHeadingWrapper = styled.div`
  text-align: left;
  margin-top: 3rem;
`;

const MobileHeadingWrapper = styled.div`
  text-align: left;
  margin-top: 1.5rem;
`;

const AccountCreatedText = () => (
  <Text>
    You can update your policy information, view your documents, make payments,
    lodge and manage a claim at our{' '}
    <a href={loginUrl()} target="_blank" rel="noopener noreferrer">
      Online Insurance Service Centre
    </a>
    .
  </Text>
);

const AccountCreated: FunctionComponent = () => (
  <>
    <Media query={{ maxWidth: SCREEN.EXTRA_SMALL }}>
      {(mobileScreen) =>
        mobileScreen ? (
          <MobileHeadingWrapper>
            <AccountCreatedHeader fontSize={3} />
            <AccountCreatedText />
          </MobileHeadingWrapper>
        ) : (
          <DesktopHeadingWrapper>
            <AccountCreatedHeader fontSize={3} />
            <AccountCreatedText />
          </DesktopHeadingWrapper>
        )
      }
    </Media>
  </>
);

export default AccountCreated;
